const list = [
  {
    id: 1,
    name: '网关',
    type: '智能联接',
    imageSrc: 'image/product/product-gw.png',
    desc: '数据传输、协议转换、安全防护、设备管' +
      '理，实现对网络流量的实时监控、威胁自动阻' +
      '断，状态可视化配置',
    jump:'hardware',
    detail:{
      list:[
        {
          name:'多WAN千兆智能WiFi网关',
          type:'LN-GW500',
          imgs:[{src:'image/product/detail/gw-detailList1.png',w:6.28}],
          spec:['自带6个千兆网口，设备采用防雷设计，内置防火墙及防病毒模块；','支持全网统一身份认证、行为管理与审计、应用层流控，拥有强大的缓存功能设计。'],
          params:[
            '型号','LN-GW500',
            '设备尺寸','440（L）*285（W)*44.5(H)',
            '物理接口','6*1000M电口，可自定义WAN/LAN',
            'CPU','高性能多核网络处理器',
            '默认管理AP数','128',
            '最大管理AP数','1024',
            '输入电压范围','AC100V-240V50/60Hz(开关电源)',
            '功耗','<65W （带硬盘）',
            '工作湿度','10% 到 95% RH无凝结',
            '存储湿度','-20℃～60℃',
            '存储温度','10% 到 95% RH无凝结',
            '工作温度','0°C～40°C',
            '推荐整机带终端数','1000台',
            '推荐接入带宽','2000M'
          ]
        },
        {
          name:'多WAN千兆智能WiFi网关',
          type:'LN-GW1000',
          imgs:[{src:'image/product/detail/gw-detailList2.png',w:6.28}],
          spec:['自带8*1000M电口、4*10G SFP+，设备采用防雷设计，内置防火墙及防病毒模块','支持全网统一身份认证、行为管理与审计、应用层流控，拥有强大的缓存功能设计。'],
          params:[
            '型号','LN-GW1000',
            '设备尺寸','440（L）*285（W)*44.5(H)',
            '物理接口','8*1000M电口、4*10G SFP+，可自定义WAN/LAN',
            'CPU','高性能多核网络处理器',
            '默认管理AP数','256',
            '最大管理AP数','2048',
            '输入电压范围','AC100V-240V50/60Hz(开关电源) ',
            '功耗','<90W （带硬盘）',
            '工作湿度','10% 到 95% RH无凝结',
            '存储湿度','-20℃～60℃',
            '存储温度','10% 到 95% RH无凝结',
            '工作温度','0°C～40°C',
            '推荐整机带终端数','5000台',
            '推荐接入带宽','10G'
          ]
        },
        {
          name:'代拨网关(流控网关)',
          type:'LN-NAS6000',
          imgs:[{src:'image/product/detail/gw-detailList3.jpg',w:6.28}],
          spec:['设备最大支持吞吐流量20G，集宽带拨号、审计与认证功能为一体，支持防共享、防代理；','系统包含应用特征库、应用识别系统、应用管理系统、打击策略四大部份，通过检测、设置、策略、功能中心、系\n' +
          '统管理、首页面板六大人机互动管理功能，对流经的所有用户应用、终端数据进行实时监控与管理。'],
          params:[
            '型号','LN-NAS6000',
            '设备尺寸','2U (W520mm x D430mm x H90mm)',
            '设备接口','6 个千兆接口;可扩展2块NIC，每块支持4*10G光口',
            '功耗','冗余电源，最大功率550W',
            '电源电压','220V交流电 ',
            '工作湿度','10% 到 95% RH无凝结',
            '存储湿度','-20℃～60℃',
            '存储温度','5%到95% RH无凝结',
            '工作温度','0°C～40°C',
            '传输介质','五类线、超五类线、六类线、光纤',
          ]
        }
      ]
    }
  },
  {
    id: 2,
    name: '交换机',
    type: '智能联接',
    imageSrc: 'image/product/product-sw.png',
    desc:'数据交换、流量监控、环路预防、配置管' +
      '理，实现对网络数据包的实时转发、异常自动' +
      '检测，拓扑可视化操作',
    jump:'hardware',
    detail: {
      list:[
        {
          name:'全千兆管理型交换机',
          type:'LN-S3500-16F-8G',
          imgs:[{src:'image/product/detail/sw-detailList11.png',w:6.28}],
          spec:['16个千兆SFP光口、8个千兆自适应电口，交换机容量350Gbps，包转发率222Mbps','支持IEEE 802.3u/ab/z/az等协议标准。'],
          params:[
            '型号','LN-S3500-16F-8G',
            '设备尺寸','440(L)×285(W)×44.5(H)mm',
            '设备接口','16个千兆SFP光口;8个10/100/1000M电口',
            '功耗','<60W',
            'MAC地址','16K MAC地址表，自动更新，双向学习',
            '交换容量','350Gbps',
            '包转发','222Mpps',
            'VLAN配置','基于端口VLAN，最多4096个VLAN，802.1Q标准 VLAN',
            '协议标准','IEEE 802.3,10BASE-T以太网;' +
            'IEEE 802.3u，快速以太网标准;IEEE 802.3ab，千兆以太网标准;IEEE 802.3z，千兆以太网光纤标准;IEEE 802.3az,EEE高效节能以太网标准',
            '',''
          ]
        },
        {
          name:'万兆上联管理型交换机',
          type:'LN-S5300-24G-4T',
          imgs:[{src:'image/product/detail/sw-detailList12.png',w:6.28}],
          spec:['24个千兆自适应电口、4个万兆SFP+光口（兼容千兆），交换机容量336Gbps，包转发率126Mbps；','支持全端口线速转发；','支持IEEE 802.3u/ab/z/az等协议标准。'],
          params:[
            '型号','LN-S5300-24G-4T',
            '设备尺寸','440(L)×208(W)×45(H)mm',
            '设备接口','24个10/100/1000M电口;4个万兆SFP+光口（兼容千兆）',
            '功耗','<36W',
            'MAC地址','16K MAC地址表，自动更新，双向学习',
            '交换容量','336Gbps',
            '包转发','126Mpps',
            'VLAN配置','基于端口VLAN，最多4096个VLAN，802.1Q标准 VLAN',
            '协议标准','IEEE 802.3,10BASE-T以太网;' +
            'IEEE 802.3u，快速以太网标准;IEEE 802.3ab，千兆以太网标准;IEEE 802.3z，千兆以太网光纤标准;IEEE 802.3az,EEE高效节能以太网标准',
            '',''
          ]
        },
        {
          name:'万兆上联管理型交换机',
          type:'LN-S5300-24F-4T',
          imgs:[{src:'image/product/detail/sw-detailList13.png',w:6.28}],
          spec:[
            '24个千兆SFP光口、8个千兆复用电口、4个万兆SFP+光口（兼容千兆），交换机容量336Gbps，包转发率126Mbps',
            '支持全端口线速转发；',
            '支持IEEE 802.3u/ab/z/az等协议标准。'
          ],
          params:[
            '型号','LN-S5300-24F-4T',
            '设备尺寸','440(L)×285(W)×44.5(H)mm',
            '设备接口','24个千兆SFP光口、8个10/100/1000M复用电口;4个万兆SFP+光口（兼容千兆）',
            '功耗','<72W',
            'MAC地址','16K MAC地址表，自动更新，双向学习',
            '交换容量','336Gbps',
            '包转发','126 Mpps',
            'VLAN配置','基于端口VLAN，最多4096个VLAN，802.1Q标准 VLAN',
            '协议标准','IEEE 802.3,10BASE-T以太网;' +
            'IEEE 802.3u，快速以太网标准;IEEE 802.3ab，千兆以太网标准;IEEE 802.3z，千兆以太网光纤标准;IEEE 802.3az,EEE高效节能以太网标准',
            '',''
          ]
        },
        {
          name:'万兆管理型交换机',
          type:'LN-S7500-15T-8G',
          imgs:[{src:'image/product/detail/sw-detailList14.png',w:6.28}],
          spec:[
            '8个千兆自适应电口、15个万兆SFP+光口（兼容千兆），交换机容量2.56Tbps，包转发率720Mbps；',
            '支持全端口线速转发；',
            '支持IEEE 802.3u/ab/z/az等协议标准。'
          ],
          params:[
            '型号','LN-S7500-15T-8G',
            '设备尺寸','440(L)×285(W)×44.5(H)mm',
            '设备接口','8个10/100/1000M电口;15个万兆SFP+光口（兼容千兆）',
            '功耗','<72W',
            'MAC地址','16K MAC地址表，自动更新，双向学习',
            '交换容量','2.56Tbps',
            '包转发','720 Mpps',
            'VLAN配置','基于端口VLAN，最多4096个VLAN，802.1Q标准 VLAN',
            '协议标准','IEEE 802.3,10BASE-T以太网;' +
            'IEEE 802.3u，快速以太网标准;IEEE 802.3ab，千兆以太网标准;IEEE 802.3z，千兆以太网光纤标准;IEEE 802.3az,EEE高效节能以太网标准',
            '',''
          ]
        },
        {
          name:'千兆管理型POE交换机',
          type:'LN-S3026-24P',
          imgs:[{src:'image/product/detail/sw16.png',w:6.28}],
          spec:[
            '24个千兆自适应POE口，2个千兆SFP光口，交换机容量336Gbps，包转发率126Mbps，PoE 最大输出功率 370W；',
            '支持 802.3af和802.3at供电。',
          ],
          params:[
            '型号','LN-S3026-24P',
            '设备尺寸','440(L)×285(W)44.5(H)mm',
            '设备接口','24个10/100/1000M  POE口;2个千兆SFP光口',
            'Console管理口','1个',
            '复位键','无',
            '供电标准','IEEE802.3af/at',
            '端口最高输出功率','30W',
            '功率','整机最高450W，POE最高输出370W',
            '交换容量','128Gbps',
            '转发模式','全线速存储转发',
            '包转发率','126Mpps',
            '工作温度','-20~50°C',
            '存储温度','-40~70°C',
            '工作湿度','10%～90%无凝结',
            '存储湿度','5%～95%无凝结',
            '输入电源','AC：110～240V/50～60Hz/450W',
            '整机重量','<8Kg',
            'LED指示灯','Power，Link/Act，POE Status',
            '节能环保','符合国际“EEE”环保节能标准',
            'POE','端口供电优先级管理，端口智能重启，端口定时供电',
            '协议标准','IEEE 802.3af，以太网供电POE标准;IEEE 802.3at，以太网供电POE+标准;IEEE 802.3u，快速以太网标准;IEEE 802.3ab，千兆以太网标准;IEEE 802.3z，千兆以太网光纤标准'
          ]
        },
        {
          name:'千兆管理型POE交换机',
          type:'LN-S3010-8P',
          imgs:[{src:'image/product/detail/sw-detailList15.png',w:6.28}],
          spec:[
            '8个千兆自适应POE口，2个千兆SFP光口，交换机容量128Gbps，包转发率102Mbps，PoE 最大输出功率 120W；',
            '支持 802.3af和802.3at供电。；',
          ],
          params:[
            '型号','LN-S3010-8P',
            '设备尺寸','280（L）*180(W)*44(H)mm',
            '设备接口','8个10/100/1000M POE口;2个千兆SFP光口',
            'Console管理口','1个',
            '复位键','无',
            '供电标准','IEEE802.3af/at',
            '端口最高输出功率','30W',
            '功率','整机最高150W，POE最高输出125W',
            '交换容量','128Gbps',
            '转发模式','全线速存储转发',
            '包转发率','102Mpps',
            '工作温度','-20~50°C',
            '存储温度','-40~70°C',
            '工作湿度','10%～90%无凝结',
            '存储湿度','5%～95%无凝结',
            '输入电源','AC：110～240V/50～60Hz/150W',
            '整机重量','<2.5Kg',
            'LED指示灯','Power，Link/Act，POE Status',
            '节能环保','符合国际“EEE”环保节能标准',
            'POE','端口供电优先级管理，端口智能重启，端口定时供电',
            '协议标准','IEEE 802.3af，以太网供电POE标准;IEEE 802.3at，以太网供电POE+标准;IEEE 802.3u，快速以太网标准;IEEE 802.3ab，千兆以太网标准;IEEE 802.3z，千兆以太网光纤标准'
          ]
        },
      ]
    }
  },
  {
    id: 3,
    name: 'AP',
    type: '智能联接',
    imageSrc: 'image/product/product-ap.png',
    desc: '无线覆盖、连接稳定性、数据传输、安全' +
      '管理，实现对无线设备的实时连接、性能自动' +
      '优化，状态可视化监控',
    jump:'hardware',
    detail:{
      iconHeight:'',
      list:[
        {
          name:'WiFi 5 双频1200M面板AP',
          type:'LN-APC1200QAW-P',
          imgs:[{src:'image/product/detail/ap-detailList11.png',w:3.6}],
          spec:['创新的PSE专利技术，一带一组网','支持802.11a/b/g/n/ac Wave1/Wave2协议','标准86面板盒上安装，更美观'],
          extra:'PSE',
          params:[
            '型号','LN-APC1200QAW-P',
            '无线协议','802.11a/b/g/n/ac Wave1/Wave2协议',
            '设备接口','一个千兆LAN/POE上联端口;一个千兆LAN/POE下联端口',
            '天线类型','内置天线',
            '工作频段','2.4GHz、5GHZ',
            '整机速率','1167Mbps',
            '空间流','4',
            '功能特性','支持OFDMA，支持MU-MIMO技术',
            '覆盖范围','半径5-15米( 视具体环境而定 )',
            '最大用户数','128(视具体环境而定)',
            '供电方式','802.3 af PoE标准供电（B2B模式时支持802.3at)',
            '设备功耗','≤8W',
            '射频功率','17dbm',
            '工作模式','无线AP、路由',
            '工作环境','温度0℃～40℃',
            '存储环境','温度-40℃～70℃',
            '安装方式','86面板',
            '设备尺寸','86×86×38',
          ]
        },
        {
          name:'WiFi 6 双频3000M面板AP',
          type:'LN-APX3000QFW-P',
          imgs:[{src:'image/product/detail/ap-detailList12.png',w:3.19}],
          extra:'PSE',
          spec:[
            '创新的PSE专利技术，一带一组网',
            '支持802.11a/b/g/n/ac Wave1/Wave2/ax协议；',
            '标准86面板盒上安装，更美观',
             '160M大频宽，网速翻倍；'
          ],
          params:[
            '型号','LN-APX3000QFW-P',
            '无线协议','802.11a/b/g/n/ac Wave1/Wave2/ax协议',
            '设备接口','一个千兆LAN/POE上联端口;一个千兆LAN/POE下联端口',
            '天线类型','内置天线',
            '工作频段','2.4GHz、5GHZ',
            '整机速率','2976Mbps',
            '空间流','4',
            '功能特性','支持OFDMA，支持MU-MIMO技术',
            '覆盖范围','半径5-15米( 视具体环境而定 )',
            '最大用户数','256(视具体环境而定)',
            '供电方式','802.3 af PoE标准供电（B2B模式时支持802.3at)',
            '设备功耗','≤12.94W',
            '射频功率','17dbm',
            '工作模式','无线AP、路由',
            '工作环境','温度0℃～40℃',
            '存储环境','温度-40℃～70℃',
            '安装方式','86面板',
            '设备尺寸','86 × 86 × 62',
          ]
        },
        {
          name:'WiFi 6 双频3000M面板AP',
          type:'LN-APX3000QWW',
          imgs:[{src:'image/product/detail/ap-detailList13.png',w:3.6}],
          spec:[
            '支持802.11a/b/g/n/ac Wave1/Wave2/ax协议',
            '标准86面板盒上安装，更美观；',
            '160M大频宽，网速翻倍；'
          ],
          params:[
            '型号','LN-APX3000QWW',
            '无线协议','802.11a/b/g/n/ac Wave1/Wave2/ax协议',
            '设备接口','一个千兆LAN/POE上联端口;一个千兆LAN下联端口',
            '天线类型','内置天线',
            '工作频段','2.4GHz、5GHZ',
            '整机速率','2976Mbps',
            '空间流','4',
            '功能特性','支持OFDMA，支持MU-MIMO技术',
            '覆盖范围','半径5-15米( 视具体环境而定 )',
            '最大用户数','256(视具体环境而定)',
            '供电方式','802.3 af PoE标准供电（B2B模式时支持802.3at)',
            '设备功耗','≤12.94W',
            '射频功率','17dbm',
            '工作模式','无线AP、路由',
            '工作环境','温度0℃～40℃',
            '存储环境','温度-40℃～70℃',
            '安装方式','86面板',
            '设备尺寸','86 × 86 × 62',
          ]
        },
        {
          name:'WiFi 6 双频3000M面板AP',
          type:'LN-APX3000QPW',
          imgs:[{src:'image/product/detail/ap-detailList14.png',w:3.6}],
          spec:[
            '支持802.11a/b/g/n/ac Wave1/Wave2/ax协议；',
            '标准86面板盒上安装，更美观；',
            '160M大频宽，网速翻倍；'
          ],
          params:[
            '型号','LN-APX3000QPW',
            '无线协议','802.11a/b/g/n/ac Wave1/Wave2/ax协议',
            '设备接口','一个千兆LAN/POE上联端口;四个千兆LAN下联端口',
            '天线类型','内置天线',
            '工作频段','2.4GHz、5GHZ',
            '整机速率','2976Mbps',
            '空间流','4',
            '功能特性','支持OFDMA，支持MU-MIMO技术',
            '覆盖范围','半径5-15米( 视具体环境而定 )',
            '最大用户数','256(视具体环境而定)',
            '供电方式','802.3 af PoE标准供电（B2B模式时支持802.3at)',
            '设备功耗','≤12.94W',
            '射频功率','17dbm',
            '工作模式','无线AP、路由',
            '工作环境','温度0℃～40℃',
            '存储环境','温度-40℃～70℃',
            '安装方式','86面板',
            '设备尺寸','86 × 86 × 62',
          ]
        },
        {
          name:'WiFi 6 双频3000M吸顶AP',
          type:'LN-APX3000QFC',
          imgs:[{src:'image/product/detail/ap-detailList15.png',w:3.19}],
          spec:[
            '支持802.11a/b/g/n/ac Wave1/Wave2/ax协议；',
            '支持AP与路由两种工作模式；',
            '支持AI智能漫游，支持二、三层漫游；'
          ],
          params:[
            '型号','LN-APX3000QFC',
            '无线协议','802.11a/b/g/n/ac Wave1/Wave2/ax协议',
            '设备接口','一个千兆LAN/POE上联端口;一个千兆LAN下联端口',
            '天线类型','内置天线',
            '工作频段','2.4GHz、5GHZ',
            '整机速率','2976Mbps',
            '空间流','4',
            '功能特性','支持OFDMA，支持MU-MIMO技术',
            '覆盖范围','半径5-15米( 视具体环境而定 )',
            '最大用户数','256(视具体环境而定)',
            '供电方式','802.3 af PoE标准供电（B2B模式时支持802.3at)',
            '设备功耗','≤12.94W',
            '射频功率','23dbm',
            '工作模式','无线AP、路由',
            '工作环境','温度0℃～40℃',
            '存储环境','温度-40℃～70℃',
            '安装方式','吸顶、壁挂、放装',
            '设备尺寸','195 × 195 × 39',
          ]
        },
        {
          name:'WiFi 6 双频3000M室外增强型AP',
          type:'LN-APX3000QAO',
          imgs:[{src:'image/product/detail/ap-detailList16.png',w:0.73}],
          spec:[
            '支持802.11a/b/g/n/ac Wave1/Wave2/ax协议；',
            '支持AP与路由两种工作模式；',
            '支持AI智能漫游，支持二、三层漫游；'
          ],
          params:[
            '型号','LN-APX3000QAO',
            '无线协议','802.11a/b/g/n/ac Wave1/Wave2/ax协议',
            '设备接口','一个2.5G独立光口;一个千兆LAN/POE端口',
            '天线类型','外置全向天线',
            '工作频段','2.4GHz、5GHZ',
            '整机速率','2976Mbps',
            '空间流','4',
            '功能特性','支持OFDMA，支持MU-MIMO技术',
            '覆盖范围','半径55-75米( 视具体环境而定 )',
            '最大用户数','256(视具体环境而定)',
            '供电方式','802.3 af PoE标准供电（B2B模式时支持802.3at)',
            '设备功耗','≤15W',
            '射频功率','27dbm',
            '工作模式','无线AP、路由',
            '工作环境','温度-30℃～65℃',
            '存储环境','温度-40℃～70℃',
            '安装方式','壁挂、抱杆',
            '设备尺寸','216×102×59（不含天线）',
          ]
        },
        {
          name:'WiFi 6 双频6000M高密AP',
          type:'LN-APX6000QFC',
          imgs:[{src:'image/product/detail/ap-detailList17.png',w:3.19}],
          spec:[
            '支持802.11a/b/g/n/ac Wave1/Wave2/ax协议；',
            '三射频设计，整机支持8条空间流；',
            '支持AI智能漫游，支持二、三层漫游；'
          ],
          params:[
            '型号','LN-APX6000QFC',
            '无线协议','802.11a/b/g/n/ac Wave1/Wave2/ax协议',
            '设备接口','一个千兆LAN/POE上联端口;一个5G SPF接口',
            '天线类型','内置天线',
            '工作频段','2.4GHz、5GHZ',
            '整机速率','5.375Gbps',
            '空间流','8',
            '功能特性','支持OFDMA，支持MU-MIMO技术',
            '覆盖范围','半径5-15米( 视具体环境而定 )',
            '最大用户数','512(视具体环境而定)',
            '供电方式','802.3 af PoE标准供电（B2B模式时支持802.3at)',
            '设备功耗','≤25.5W',
            '射频功率','≤23dbm',
            '工作模式','无线AP、路由',
            '工作环境','温度0℃～40℃',
            '存储环境','温度-40℃～70℃',
            '安装方式','吸顶、壁挂、放装',
            '设备尺寸','230 × 230 × 51',
          ]
        },
      ],
    }
  },
  {
    id: 4,
    name: 'OLT',
    type: '智能联接',
    imageSrc: 'image/product/product-olt.png',
    desc: '光纤接入、信号转换、带宽管理、服务监' +
      '测，实现对光网络用户的实时连接、故障自动' +
      '诊断，状态可视化运维',
    jump:'hardware',
    detail: {
      list:[
        {
          name:'10G PON 统一光接入平台',
          type:'LN-OLT3500-X17',
          imgs:[{src:'image/product/detail/olt-detailList11.png',w:3.74}],
          spec:[
            '采用业界领先的芯片级解决方案，提供丰富的软硬件特性，适应运营商接入网、园区网的长期平滑演进需求',
            'OLT3500 产品平台，提供主控单元、交换单元、电源模块和上行链路的冗余保护，满足电信级的可靠性需求。',
          ],
          params:[
            '型号','LN-OLT3500-X17',
            '业务槽位数','17',
            '供电方式','DC 电源，1+1 冗余',
            'GPON 端口数','单板最大支持 16 口',
            '10G PON 端口数','单板最大支持 16 口',
            'Combo PON 端口数','单板最大支持 16 口',
            '主控板上行','2*4*25GE/10GE',
            '上行板上行','100GE/25GE/10GE/GE',
            '可靠性设计','主控板 1+1 冗余/ PON 保护',
            '时钟特性','支持 PTP 1588V2和同步以太 SyncE',
            '典型功耗','1242 W',
            '设备尺寸','宽： 21 英寸；高： 11U',
            'PON','支持 ONU 认证（SN 认证、Password 认证、SN+Password 认证、LOID 认证）;支持前向纠错（FEC）;支持 AES 算法加密功能;支持动态带宽分配 DBA 算法;支持 PON 口发光功率，接收光功率检测，ONU 光功率监测;流氓 ONU 检测;支持 OMCI 协议',
            '以太网特性','支持 802.1Q;静态 MAC 配置;支持 MAC 地址学习数目限制;支持 MAC 地址过滤;支持端口镜像;支持划分 VLAN;支持 MSTP 协议',
            'ACL/QoS','支持标准和扩展 ACL、支持 Ingress/Egress ACL;支持流量整形;支持拥塞避免;支持 802.1p 优先级映射',
            '组播','支持 IGMP Snooping 二层组播;IGMP Proxy',
            '安全机制','支持端口隔离',
            '可靠性','支持端口聚合;支持端口限速;支持环路检测',
            '系统管理','支持 SNMP 管理;支持 CLI、Telnet 管理'
          ]
        },
        {
          name:'10G PON 统一光接入平台',
          type:'LN-OLT3500-X15',
          imgs:[{src:'image/product/detail/olt-detailList12.png',w:3.74}],
          spec:[
            '采用业界领先的芯片级解决方案，提供丰富的软硬件特性，适应运营商接入网、园区网的长期平滑演进需求',
            'OLT3500 产品平台，提供主控单元、交换单元、电源模块和上行链路的冗余保护，满足电信级的可靠性需求。',
          ],
          params:[
            '型号','LN-OLT3500-X15',
            '业务槽位数','15',
            '供电方式','DC 电源，1+1 冗余',
            'GPON 端口数','单板最大支持 16 口',
            '10G PON 端口数','单板最大支持 16 口',
            'Combo PON 端口数','单板最大支持 16 口',
            '主控板上行','2*4*25GE/10GE',
            '上行板上行','100GE/25GE/10GE/GE',
            '可靠性设计','主控板 1+1 冗余/ PON 保护',
            '时钟特性','支持 PTP 1588V2和同步以太 SyncE',
            '典型功耗','1143 W',
            '设备尺寸','宽： 19 英寸；高： 11U',
            'PON','支持 ONU 认证（SN 认证、Password 认证、SN+Password 认证、LOID 认证）;支持前向纠错（FEC）;支持 AES 算法加密功能;支持动态带宽分配 DBA 算法;支持 PON 口发光功率，接收光功率检测，ONU 光功率监测;流氓 ONU 检测;支持 OMCI 协议',
            '以太网特性','支持 802.1Q;静态 MAC 配置;支持 MAC 地址学习数目限制;支持 MAC 地址过滤;支持端口镜像;支持划分 VLAN;支持 MSTP 协议',
            'ACL/QoS','支持标准和扩展 ACL、支持 Ingress/Egress ACL;支持流量整形;支持拥塞避免;支持 802.1p 优先级映射',
            '组播','支持 IGMP Snooping 二层组播;IGMP Proxy',
            '安全机制','支持端口隔离',
            '可靠性','支持端口聚合;支持端口限速;支持环路检测',
            '系统管理','支持 SNMP 管理;支持 CLI、Telnet 管理'
          ]
        },
        {
          name:'10G PON 统一光接入平台',
          type:'LN-OLT3500-X8',
          imgs:[{src:'image/product/detail/olt-detailList13.png',w:3.74}],
          spec:[
            '采用业界领先的芯片级解决方案，提供丰富的软硬件特性，适应运营商接入网、园区网的长期平滑演进需求',
            'OLT3500 产品平台，提供主控单元、交换单元、电源模块和上行链路的冗余保护，满足电信级的可靠性需求。',
          ],
          params:[
            '型号','LN-OLT3500-X8',
            '业务槽位数','8',
            '供电方式','DC 电源，1+1 冗余',
            'GPON 端口数','单板最大支持 16 口',
            '10G PON 端口数','单板最大支持 16 口',
            'Combo PON 端口数','单板最大支持 16 口',
            '主控板上行','2*4*25GE/10GE',
            '上行板上行','100GE/25GE/10GE/GE',
            '可靠性设计','主控板 1+1 冗余/ PON 保护',
            '时钟特性','支持 PTP 1588V2和同步以太 SyncE',
            '典型功耗','754 W',
            '设备尺寸','宽：19 英寸；高：7U',
            'PON','支持 ONU 认证（SN 认证、Password 认证、SN+Password 认证、LOID 认证）;支持前向纠错（FEC）;支持 AES 算法加密功能;支持动态带宽分配 DBA 算法;支持 PON 口发光功率，接收光功率检测，ONU 光功率监测;流氓 ONU 检测;支持 OMCI 协议',
            '以太网特性','支持 802.1Q;静态 MAC 配置;支持 MAC 地址学习数目限制;支持 MAC 地址过滤;支持端口镜像;支持划分 VLAN;支持 MSTP 协议',
            'ACL/QoS','支持标准和扩展 ACL、支持 Ingress/Egress ACL;支持流量整形;支持拥塞避免;支持 802.1p 优先级映射',
            '组播','支持 IGMP Snooping 二层组播;IGMP Proxy',
            '安全机制','支持端口隔离',
            '可靠性','支持端口聚合;支持端口限速;支持环路检测',
            '系统管理','支持 SNMP 管理;支持 CLI、Telnet 管理'
          ]
        },
        {
          name:'10G PON 统一光接入平台',
          type:'LN-OLT3500-X2',
          imgs:[{src:'image/product/detail/olt-detailList14.png',w:3.74}],
          spec:[
            '采用业界领先的芯片级解决方案，提供丰富的软硬件特性，适应运营商接入网、园区网的长期平滑演进需求',
            'OLT3500 产品平台，提供主控单元、交换单元、电源模块和上行链路的冗余保护，满足电信级的可靠性需求。',
          ],
          params:[
            '型号','LN-OLT3500-X2',
            '业务槽位数','2',
            '供电方式','AC电源，1+1冗余',
            'GPON 端口数','单板最大支持 16 口',
            '10G PON 端口数','单板最大支持 16 口',
            'Combo PON 端口数','单板最大支持 16 口',
            '主控板上行','2*4*25GE/10GE',
            '上行板上行','100GE/25GE/10GE/GE',
            '可靠性设计','主控板 1+1 冗余/ PON 保护',
            '时钟特性','支持 PTP 1588V2和同步以太 SyncE',
            '典型功耗','308 W',
            '设备尺寸','宽：19 英寸；高：2U',
            'PON','支持 ONU 认证（SN 认证、Password 认证、SN+Password 认证、LOID 认证）;支持前向纠错（FEC）;支持 AES 算法加密功能;支持动态带宽分配 DBA 算法;支持 PON 口发光功率，接收光功率检测，ONU 光功率监测;流氓 ONU 检测;支持 OMCI 协议',
            '以太网特性','支持 802.1Q;静态 MAC 配置;支持 MAC 地址学习数目限制;支持 MAC 地址过滤;支持端口镜像;支持划分 VLAN;支持 MSTP 协议',
            'ACL/QoS','支持标准和扩展 ACL、支持 Ingress/Egress ACL;支持流量整形;支持拥塞避免;支持 802.1p 优先级映射',
            '组播','支持 IGMP Snooping 二层组播;IGMP Proxy',
            '安全机制','支持端口隔离',
            '可靠性','支持端口聚合;支持端口限速;支持环路检测',
            '系统管理','支持 SNMP 管理;支持 CLI、Telnet 管理'
          ]
        },
      ]
    }
  },
  {
    id: 5,
    name: 'ODN',
    type: '智能联接',
    imageSrc: 'image/product/product-odn.png',
    desc: '信号传输、分支分配、无源设计、网络构' +
      '建，实现对光信号的高效分发和管理，确保OL' +
      'T与ONU之间的稳定通信',
  },
  {
    id: 6,
    name: 'MDU',
    type: '智能联接',
    imageSrc: 'image/product/product-mdu.png',
    desc: '集中管理、带宽共享、网络优化、光纤接' +
      '入，实现对多住户网络的高效分配、数据稳定' +
      '传输，设备运行可视化监控',
    jump:'hardware',
    detail: {
      list:[
        {
          name:'PON 上行的网络设备',
          type:'LN-MDU404P',
          imgs:[{src:'image/product/detail/mdu-detailList11.png',w:6.28}],
          spec:[
            '支持二层数据转发功能，具有电信级可运营、可管理、易维护的特点,为客户提供高速数据业务',
          ],
          params:[
            '型号','LN-MDU404P',
            '设备尺寸','200*120*35mm',
            '电源输出','100V~240V AC,50Hz~60Hz；  52V~1.25A',
            '整机最大功率','65W',
            '工作环境温度','-10°C ~ +45°C',
            '工作环境湿度','5%~95%（非冷凝）',
            '端口防雷设计','共模 6KV;差模 1.5KV',
            '静电防护','空气： 15KV；  接触： 8KV',
            '按钮','复位按钮',
            '调试接口','Console',
            '用户接口','4×GE POE 自适应以太网接口，  RJ45 连接器',
            '遵循标准','IEEE 802.3af、  IEEE8023at',
            '供电线序','1/2(+) ，  3/6(-)POE',
            '单端口最大功率','30W',
          ]
        },
        {
          name:'PON 上行的网络设备',
          type:'MDU-LN-MDU408P',
          imgs:[{src:'image/product/detail/mdu-detailList12.png',w:6.28}],
          spec:[
            '支持二层数据转发功能，具有电信级可运营、可管理、易维护的特点,为客户提供高速数据业务',
          ],
          params:[
            '型号','MDU-LN-MDU408P',
            '设备尺寸','220*150*35mm',
            '电源输出','100V~240V AC,50Hz~60Hz，52V~2.3A',
            '整机最大功率','120W',
            '工作环境温度','-10°C ~ +45°C',
            '工作环境湿度','5%~95%（非冷凝）',
            '端口防雷设计','共模 6KV;差模 1.5KV',
            '静电防护','空气： 15KV；  接触： 8KV',
            '按钮','复位按钮',
            '调试接口','Console',
            '用户接口','8×GE POE 自适应以太网接口，  RJ45 连接器',
            '遵循标准','IEEE 802.3af、  IEEE8023at',
            '供电线序','1/2(+) ，  3/6(-)POE',
            '单端口最大功率','30W',
          ]
        },
      ]
    }
  },
  {
    id: 7,
    name: '光AP',
    type: '智能联接',
    imageSrc: 'image/product/product-gap.png',
    desc: '光纤接入、无线覆盖、性能稳定、易扩展，' +
      '实现对光纤信号的高效转换和无线网络的广泛' +
      '覆盖，设备运行可视化管理',
    jump:'hardware',
    detail: {
      list:[
        {
          name:'高性能 PON 上行的WiFi6',
          type:'LN-APX3000QFW-GP',
          imgs:[{src:'image/product/detail/gap-detailList1.png',w:3.19}],
          spec:[
            '支持二层数据转发功能。',
            '具有电信级可运营、可管理、易维护的特点,为客户提供高速数据业务。',
          ],
          params:[
            '型号','LN-APX3000QFW-GP',
            '设备尺寸','160*86*38mm',
            '设备接口','1 个 XPON 端口(EPON PX20+和 GPON Class B+);4*GE  以太网接口（RJ45）',
            '调试接口','Console',
            '电源输入','DC 36-55V',
            '整机最大功率','17W',
            '工作环境温度','-10°C ~ +45°C',
            '工作环境湿度','5%~95%（非冷凝）',
            '端口防雷设计','共模 6KV;差模 1.5KV',
            '静电防护','空气：  15KV；  接触：  8KV',
            '按钮','复位按钮',
            '指示灯','双色：  系统 /绿色, GPON 状态/红色',
            '无线协议','2.4G：2*2 （支持 IEE 802.11b/g/n/ac/ax 协议）;5G：2*2 （支持 IEE 802.11a/n/ac/ax协议,支持 160MHz频宽）',
            '无线速率','2.4GHz：574Mbps;5GHz：2402Mbps'
          ]
        },
      ]
    }
  },
  {
    id: 30,
    name: '防代理系统',
    type: '智能联接',
    imageSrc: 'image/product/product-dl.png',
    desc: '实时监控、故障预警、配置管理、性能分析，对网络设备和流量实现全面监视、事件自动告警，通过可视化界面展示网络状态”格式写防代理系统',
    jump:'hardware',
    detail:{
      iconHeight:'',
      list:[
        {
          name:'防代理',
          type:'LN-PSS6000',
          imgs:[{src:'image/product/product-dl.png',w:5.36}],
          spec:['精准的应用识别技术；','全面终端类型、系统类型、浏览器识别；','灵活的接入方式；','多种检测策略；'],
          params:[
            '型号','LN-PSS6000',
            '设备尺寸','2U (W520mm x D430mm x H90mm)',
            '吞吐流量','20G',
            '支持用户','11000IP在线',
            '管理接口','1 个 Console 口、1 个 MGT 管理、;2个USB2.0 口',
            '网络接口','2 个千兆接口 8个万兆接口（可扩展接口）',
            '电源规格','冗余电源，最大功率850W',
            '',''
          ]
        },
      ],
    }
  },
  {
    id: 8,
    name: '认证计费系统',
    type: '运维管理',
    imageSrc: 'image/product/product-jfrz.png',
    desc: '身份验证、安全保障、费用计算、数据记录，对用户实现实时认证、使用情况自动计费，账单可视化展示',
    jump:'soft',
    detail: {
      desc:'这套系统基于标准的Radius协议构建，用户界面友好，操作便捷。它广泛适用于各类环境，如教育机构、公司组织、政府部门、旅宿业以及其它提供WiFi接入的公共空间。系统支持最新的IPv4和IPv6网络协议，确保认证过程不受网络类型限制。同时，它还提供了精细化的用户访问管理以及详尽的日志审计功能，保障了网络使用的安全性和可追溯性。',
      img:{src:'image/product/detail/soft8.png',w:5.03},
      icons:[
        {src:'image/product/icon/icon81.png',title:'计费结算'},
        {src:'image/product/icon/icon82.png',title:'技术支持'},
        {src:'image/product/icon/icon83.png',title:'用户认证'},
        {src:'image/product/icon/icon85.png',title:'应用场景'},
        {src:'image/product/icon/icon85.png',title:'附加功能'},
        {src:'image/product/icon/icon86.png',title:'数据库管理'},
      ]
    }
  },
  {
    id: 9,
    name: '网管系统',
    type: '运维管理',
    imageSrc: 'image/product/product-wgxt.png',
    desc:'实时监控、故障预警、配置管理、性能分' +
      '析，对网络设备和流量实现全面监视、事件自' +
      '动告警，通过可视化界面展示网络状态',
    jump:'soft',
    detail: {
      desc:'该系统采用先进的网络管理技术构建，用户界面直观且功能齐全。它普遍适用于各种规模和类型的网络环境，如企业数据中心、服务提供商的网络基础设施、教育机构的校园网络、政府机构的通信系统以及任何需要网络监管的场景。系统兼容多种网络协议和标准，包括但不限于SNMP（简单网络管理协议），确保管理操作不受网络设备类型限制。此外，它还提供了全面的网络监控、性能评估以及故障诊断与处理功能，保障了网络运行的高效性和稳定性。',
      img:{src:'image/product/detail/soft9.png',w:6.23},
      icons:[
        {src:'image/product/icon/icon91.png',title:'配置管理'},
        {src:'image/product/icon/icon92.png',title:'性能管理'},
        {src:'image/product/icon/icon93.png',title:'故障管理'},
        {src:'image/product/icon/icon94.png',title:'安全管理'},
        {src:'image/product/icon/icon95.png',title:'支持云化引擎'},
        {src:'image/product/icon/icon96.png',title:'系统兼容性'},
        {src:'image/product/icon/icon97.png',title:'用户界面'},
        {src:'image/product/icon/icon98.png',title:'扩展性'},
        {src:'image/product/icon/icon99.png',title:'自动化'},
        {src:'image/product/icon/icon910.png',title:'报表和日志'},
      ]
    }
  },
  {
    id: 10,
    name: '运营中台',
    type: '高阶辅助',
    imageSrc: 'image/product/product-yyzt.png',
    desc: '综合协同、效率优化、决策辅助、分析预' +
      '测，对业务流程实时监控、绩效自动评估，数' +
      '据可视化展示',
    jump:'soft',
    detail: {
      desc:'这套系统基于模块化的中台架构构建，用户界面友好，操作便捷。它广泛适用于任何需要统一运营管理和数据整合的场景。系统支持多业务线的协同和数据共享，确保业务流程不受组织边界限制。同时，它还提供了灵活的服务集成、自动化流程编排以及详尽的数据分析与报表功能，保障了企业运营的效率和决策的数据支持。',
      img:{src:'image/product/detail/soft10.png',w:6.46},
      icons:[
        {src:'image/product/icon/icon101.png',title:'模块化设计'},
        {src:'image/product/icon/icon102.png',title:'多业务线支持'},
        {src:'image/product/icon/icon103.png',title:'数据共享与协同'},
        {src:'image/product/icon/icon104.png',title:'自动化流程编排'},
        {src:'image/product/icon/icon105.png',title:'灵活的服务集成'},
        {src:'image/product/icon/icon106.png',title:'安全可靠'},
        {src:'image/product/icon/icon107.png',title:'详尽的数据分析与报表'},
        {src:'image/product/icon/icon108.png',title:'可扩展性与定制性'},
        {src:'image/product/icon/icon109.png',title:'用户友好的界面'},
        {src:'image/product/icon/icon1010.png',title:'跨终端访问'},
      ]
    }
  },
  {
    id: 11,
    name: '运维工单',
    type: '高阶辅助',
    imageSrc: 'image/product/yygd.png',
    desc:'故障响应、任务调度、流程追踪、记录归' +
      '档，实现对维护任务的即时派发、进度自动更' +
      '新，操作可视化管理',
    jump:'soft',
    detail: {
      desc:'这套系统采用先进的任务管理技术构建，用户界面直观且功能全面。它广泛适用于各种规模和类型的组织环境，系统支持多种工作流和任务类型，确保任务处理不受服务种类限制。同时，它还提供了详细的问题追踪、资源分配以及时间线管理功能，保障了运维活动的高效性和响应性。',
      img:{src:'image/product/detail/soft11.png',w:6.94},
      icons:[
        {src:'image/product/icon/icon111.png',title:'工单管理'},
        {src:'image/product/icon/icon112.png',title:'流程定制'},
        {src:'image/product/icon/icon113.png',title:'集中协作'},
        {src:'image/product/icon/icon114.png',title:'实时监控'},
        {src:'image/product/icon/icon115.png',title:'通知与提醒'},
        {src:'image/product/icon/icon116.png',title:'数据分析'},
        {src:'image/product/icon/icon117.png',title:'移动访问'},
        {src:'image/product/icon/icon118.png',title:'集成能力'},
        {src:'image/product/icon/icon119.png',title:'安全性'},
        {src:'image/product/icon/icon1110.png',title:'可扩展性'},
      ]
    }
  },
  {
    id: 27,
    name: '客服系统',
    type: '高阶辅助',
    imageSrc: 'image/product/product-kfxt.png',
    desc: '需求捕捉、问题解析、服务导向、交互记' +
      '录，实现对客户请求的即时响应、问题自动分' +
      '类，服务过程可视化监控',
    jump:'soft',
    detail: {
      desc:'该系统采用高效的客户服务管理技术构建，用户界面直观且互动性强。它广泛适用于多种业务场景，系统与多种通信渠道兼容，包括电话、电子邮件、在线聊天和社交媒体，确保客户能够通过不同方式轻松联系客服。同时，它还提供了深入的客户数据分析、个性化服务记录以及智能的问题解决指引功能，保障了客户服务的高效性和个性化。',
      img:{src:'image/product/detail/soft27.png',w:6.75},
      icons:[
        {src:'image/product/icon/icon271.png',title:'多渠道支持'},
        {src:'image/product/icon/icon272.png',title:'服务记录'},
        {src:'image/product/icon/icon273.png',title:'客户数据分析'},
        {src:'image/product/icon/icon274.png',title:'智能问题解决'},
        {src:'image/product/icon/icon275.png',title:'知识库管理'},
        {src:'image/product/icon/icon276.png',title:'自动化流程'},
        {src:'image/product/icon/icon277.png',title:'实时监控与报告'},
        {src:'image/product/icon/icon278.png',title:'安全性与合规性'},
        {src:'image/product/icon/icon279.png',title:'集成能力'},
        {src:'image/product/icon/icon2710.png',title:'可扩展性'},
      ]
    }
  },
  {
    id: 28,
    name: '审计系统',
    type: '高阶辅助',
    imageSrc: 'image/product/product-sjxt.png',
    desc:'合规检查、风险识别、报告生成、数据留' +
      '存，实现对操作和交易的实时审查、异常自动' +
      '标记，审计结果可视化呈现',
    jump:'soft',
    detail: {
      desc:'该系统基于综合的审计标准构建，用户界面直观，操作简便。它广泛适用于多种业务和环境，系统支持多种审计标准和流程，确保审计活动不受业务类型限制。同时，它还提供了全面的事务监控、风险评估以及自动化报告生成功能，保障了审计过程的准确性和透明度。审计内容符合公安部第 82 号令和第 151 号令《互联网安全保护技术措施规定》信息留存及监督的要求。',
      img:{src:'image/product/detail/soft028.png',w:4.63},
      icons:[
        {src:'image/product/icon/icon281.png',title:'日志管理'},
        {src:'image/product/icon/icon282.png',title:'数据库监控'},
        {src:'image/product/icon/icon283.png',title:'全面准确的审计'},
        {src:'image/product/icon/icon284.png',title:'高效入库与分析'},
        {src:'image/product/icon/icon285.png',title:'用户友好'},
        {src:'image/product/icon/icon286.png',title:'加密协议解析'},
        {src:'image/product/icon/icon287.png',title:'多维度策略'},
        {src:'image/product/icon/icon288.png',title:'实时监控与告警'},
        {src:'image/product/icon/icon289.png',title:'智能关联分析'},
        {src:'image/product/icon/icon2810.png',title:'双向审计'},
        {src:'image/product/icon/icon2811.png',title:'日志检索与可视化分析'},
      ]
    }
  },
  {
    id: 12,
    name: '进销存系统',
    type: '高阶辅助',
    imageSrc: 'image/product/product-jxc.png',
    desc: '库存监控、流程优化、数据分析、记录追' +
      '溯，实现对物品流转的实时跟踪、库存异常自' +
      '动提醒，数据可视化管理',
    jump:'soft',
    detail: {
      desc:'该系统基于现代供应链管理理念构建，用户界面直观，操作简便。系统支持多渠道的库存跟踪和优化，确保进销存过程不受种类限制。同时，它还提供了实时的库存监控、订单处理以及详尽的分析报告功能，保障了库存管理的效率和准确性。',
      img:{src:'image/product/detail/soft12.png',w:7.03},
      icons:[
        {src:'image/product/icon/icon121.png',title:'进货管理'},
        {src:'image/product/icon/icon122.png',title:'出库管理'},
        {src:'image/product/icon/icon123.png',title:'库存控制'},
        {src:'image/product/icon/icon124.png',title:'操作简便'},
        {src:'image/product/icon/icon125.png',title:'报表与分析'},
        {src:'image/product/icon/icon126.png',title:'数据同步与共享'},
        {src:'image/product/icon/icon127.png',title:'权限管理与安全性'},
        {src:'image/product/icon/icon128.png',title:'集成与扩展'},
        {src:'image/product/icon/icon129.png',title:'移动访问'},
      ]
    }
  },
  {
    id: 13,
    name: 'CRM系统',
    type: '高阶辅助',
    imageSrc: 'image/product/product-crm.png',
    desc:'客户洞察、关系维护、销售自动化、数据分析，实现对客户互动的实时跟踪、商机自动捕捉，数据可视化分析',
    jump:'soft',
    detail: {
      desc:'这套系统基于客户关系管理的理念构建，用户界面直观，操作便捷。系统支持多渠道的客户互动和数据分析，确保客户服务和营销活动不受地域限制。同时，它还提供了全面的客户资料整合、销售机会跟踪以及深入的客户行为分析功能，保障了客户关系维护的效率和效果。',
      img:{src:'image/product/detail/soft13.png',w:6.77},
      icons:[
        {src:'image/product/icon/icon131.png',title:'客户数据管理'},
        {src:'image/product/icon/icon132.png',title:'客户互动跟踪'},
        {src:'image/product/icon/icon133.png',title:'销售过程管理'},
        {src:'image/product/icon/icon134.png',title:'客户服务提升'},
        {src:'image/product/icon/icon135.png',title:'多渠道支持'},
        {src:'image/product/icon/icon136.png',title:'数据分析与报告'},
        {src:'image/product/icon/icon137.png',title:'客户细分与个性化'},
        {src:'image/product/icon/icon138.png',title:'集成与扩展性'},
        {src:'image/product/icon/icon139.png',title:'用户友好性'},
      ]
    }

  },
  {
    id: 14,
    name: '上网管控',
    type: '高阶辅助',
    imageSrc: 'image/product/product-swgk.png',
    desc: '访问控制、内容过滤、行为监控、安全报' +
      '告，实现对上网流量的实时管理、违规行为自' +
      '动拦截，统计报告可视化呈现',
    jump:'soft',
    detail: {
      desc:'这套系统基于客户关系管理的理念构建，用户界面直观，操作便捷。系统支持多渠道的客户互动和数据分析，确保客户服务和营销活动不受地域限制。同时，它还提供了全面的客户资料整合、销售机会跟踪以及深入的客户行为分析功能，保障了客户关系维护的效率和效果。',
      img:{src:'image/product/detail/soft14.png',w:6.78},
      icons:[
        {src:'image/product/icon/icon141.png',title:'网络访问控制'},
        {src:'image/product/icon/icon142.png',title:'应用管理'},
        {src:'image/product/icon/icon143.png',title:'可扩展性和兼容性'},
        {src:'image/product/icon/icon144.png',title:'行为记录与审计'},
        {src:'image/product/icon/icon145.png',title:'用户身份认证'},
        {src:'image/product/icon/icon146.png',title:'策略定制与执行'},
        {src:'image/product/icon/icon147.png',title:'远程管理与监控'},
        {src:'image/product/icon/icon148.png',title:'界面友好易用'},
        {src:'image/product/icon/icon149.png',title:'带宽管理'},
      ]
    }
  },
  {
    id: 15,
    name: '宿舍水电控设备',
    type: '智能终端',
    imageSrc: 'image/product/product-shsd.png',
    desc: '自动监测、定额管理、使用优化、安全保护，实现对宿舍水电费的实时统计、超出预设值自动断电断水，用量和安全状态可视化监控',
    jump:'hardware',
    detail:{
      list:[
        {
          name:'智慧校园',
          type:'智能水表',
          imgs:[{src:'image/product/detail/znsbDetailList1.png',w:4.5}],
          spec:[
            '流畅外观设计，尽显流行时尚，同时支持4G网络和蓝牙系统；',
            '卡余额和APP账户余额共用钱包，无须额外充值；',
            '独特扣费精确到厘，扣费更精确，更准确；',
            '异常干扰自动关阀功能：遇外界强磁干扰时，自动关阀；',
            '一体化及防水设计，使产品更直观明了施工简单更易于维护；',
            '采用计时和计量方式扣费，可以对费率进行灵活设置，符合各种需求；',
            '安装更简单，接线更方便，无须额外布线，节约人力物力财力；',
            '采用微信/支付宝充值，既方便快捷又安全无忧；',
            '学生自主绑卡、解绑卡，彻底解决掉卡后带来的经济风险；',
            '共用4G网络和蓝牙系统，即使运营商网络信号不好，也可用蓝牙通讯进行消费，保证学生正常用水；'
          ],
          params:[
            '产品型号','M750(4G)',
            '卡片种类','M1卡、FM1208-09型号CPU卡、7+1复合卡',
            '操作距离','0–25mm',
            '工作电压','12VDC',
            '工作频率','50HZ',
            '正常工作电流','440MA',
            '待机工作电流','100MA',
            '待机功率','1.2W',
            '正常工作功率','5.3W',
            '网络通讯方式','MQTT',
            '接入方式','4G网络实时联网',
            '使用方式','4G网络与蓝牙',
            '环境温度','0℃-90℃.',
            '耐压性','<=1.0MPa',
            '电磁阀','在0.03-0.8MPa时，正常开阀',
            '计费精度','0.001 元.',
            '蓝牙连接距离','5M内',
            '最大累计消费总额','4000万.',
            '尺寸','长185mm    宽92mm    高99mm',
            '','',
          ]
        },
      ]
    }
  },
  {
    id: 16,
    name: '智能饮用热水设备',
    type: '智能终端',
    imageSrc: 'image/product/product-znyy.png',
    desc: '水温调控、能效管理、用量监测、安全保障，实现对热水供应的即时加热、消耗自动跟踪，使用状态和能耗可视化管理'
  },
  {
    id: 17,
    name: '通道闸机',
    type: '智能终端',
    imageSrc: 'image/product/product-tdzj.png',
    desc: '出入控制、安全监测、流量统计、数据记' +
      '录，实现对人员进出的实时管理、非法入侵自' +
      '动报警，访问数据可视化分析'
  },
  {
    id: 18,
    name: '人脸门禁机',
    type: '智能终端',
    imageSrc: 'image/product/product-rlmj.png',
    desc: '身份识别、出入管理、安全监控、记录查询，实现对人员进出的无接触式控制、未授权进入自动拦截，访问记录可视化管理',
    jump:'hardware',
    detail:{
      list:[
        {
          name:'智慧校园',
          type:'人脸门禁终端',
          imgs:[{src:'image/product/detail/rlmjDetailList1.png',w:4.11}],
          spec:[
            '宽动态双摄活体防伪，彻底解决各类照片在各种载体上的欺骗；',
            '夜间红外、RGB双补灯；',
            '支持串口、韦根26、34输出输入，输出内容支持配置；',
            '采用基于视频流的动态人脸检测、跟踪识别算法；',
            '支持M1卡门禁刷卡开门,支持2000枚手指指纹的存储；',
            '支持设备本地存储万人库：',
          ],
          params:[
            '摄像头分辨率','200W',
            '摄像头类型','RGB+红外',
            '摄像头光圈','4.0mm',
            '摄像头焦距','0-2M',
            '摄像头白平衡','自动',
            '屏幕尺寸','8英寸，全视角IPS液晶屏',
            '屏幕分辨率','1280*800,亮度400cd',
            '处理器CPU','4核 RK3288',
            '内存','2+8GB',
            'ISP','内置双路ISP',
            '补光灯','红外、LED补光',
            '指纹模块','USB指纹模块',
            '网络模块','网络模块',
            '音频','一路音频line out',
            'USB接口','USB2.0 micro 2个',
            '串口232','2路RS232接口， 1路WG输入、1路WG输出',
            '韦根接口','2.5mmX2PIN',
            '本地离线使用','本地2W人脸库',
            '1:N人脸识别','支持万分之一的误识率，99%的通过率',
            '1:01:00','支持选配刷卡模块，身份证模块可实现1:1人脸比对',
            '陌生人检测','支持',
            '识别距离设置','支持',
            '设备远程升级','支持',
            '设备接口','设备管理、权限管理、人员/照片管理、记录查询等',
            '防护等级','IP55支持半户外使用<span style="color: red">（不能淋雨）</span>',
            '电源','DC12V',
            '工作温度','15-30°',
            '工作湿度','10%—90%',
            '静电','4K/8K',
            '电磁辐射','无频点超标',
            '功耗','5W MAX',
            '安装方式','壁挂、台面支架、闸机安装、落地式支架',
            '设备重量','1.9KG',
            '设备尺寸','274.2*133*24.5mm',
          ]
        },
      ]
    }

  },
  {
    id: 19,
    name: '三刷智能消费机',
    type: '智能终端',
    imageSrc: 'image/product/product-shzn.png',
    desc: '支付便捷、消费记录、数据同步、财务报' +
      '表，实现对交易的即时处理、账目自动更新，' +
      '消费数据可视化统计',
    jump:'hardware',
    detail:{
      list:[
        {
          name:'智慧校园',
          type:'三刷消费机',
          imgs:[{src:'image/product/detail/xfjjDetailList1.png',w:4.11}],
          spec:[
            '终端识别速度快：刷脸离线识别平均只需要300毫秒;',
            '学生隐私保护：小程序采集人脸照片加密上传并存储在支付宝侧；',
            '家长资金安全：平台对订单进行风控，异常订单禁止扣款；',
            '家长放心子女消费：家长可查看学生就餐、消费信息；',
            '商户收款放心：提供平台垫资能力，确保收款安全；',
            '支付安全：搭载活体检测等功能，人脸识别具有唯一性与防攻击性；',
            '性能强劲：采用高通骁龙八核处理器：',
            '方便卫生：减少与机具的接触，降低传染病菌风险：',
            '在线升级：可通过支付宝开放平台或乐舜设备管理平台进行系统升级：',
            '机具时钟自动校准：周期性与后台服务器进行时钟同步：',
            '适配安装场景广：自带SPCC挂架，磨砂涂层，防指纹，耐高温：',
            '可拆卸机械键盘：耐磨防油防水，可安装或拆下来使用。',
          ],
          params:[
            '产品重量','约1050克（整机，不包括配件），约1500克（带挂架）',
            '产品尺寸','长×宽×高 242mm158mm40mm',
            '电源输入','电压输入 12VDC，最大电流3A;接口为带锁扣的DC 5.52x1插座',
            '额定功率','24W，最大不超过36W',
            '工作环境','最大温度 -10℃～+50℃，湿度 10%~90%;推荐温度 -10℃~+40℃，湿度 10%~80%',
            '双屏显示','支持',
            '操作屏','5英寸IPS液晶屏，分辨率 480*854',
            '客显屏','8英寸IPS液晶屏，分辨率 800*1280',
            '触摸屏','8英寸电容触摸屏，多点触控G+G',
            'CPU及主频','8核1.8GHz A53，高通骁龙450处理器',
            '内存','2GB LPDDR3 RAM',
            'FLASH','16GB eMMC',
            '喇叭数量','2个',
            '每路额定功率','2W@5V/4Ω/1KHz',
            '频率响应','680Hz～20KHz',
            '信噪比','86dB@5V/THD=1%/1KHz',
            'SPL','99dB@2KHz/2W',
            'RTC时钟电池','有，掉电可保持时间，电池寿命 >2年',
            '网络接口','通讯协议 10/100Mbps Base-T 自适应;接口方式 RJ45',
            'WIFI','通讯频段 2.4G/5G 双通道;通讯协议 802.11a/b/g/n/ac',
            '蓝牙','BT 4.2 (BR/EDR+BLE)',
            '蜂窝网络','通讯频段 LTE-FDD: B1/B3/B5/B8;LTE-TDD: B38/B39/B40/B41。',
            '非接触式读卡','读卡距离 3~5cm；读写时间 <0.5秒;工作频率 13.56MHz +/-7KHz',
            '扫码头','支持多种二维码和一维码格式;最佳扫码距离 40~160mm',
            'USB接口','2个 USB 2.0，type-A 接口;每路输出电压 4.8V~5.2V，输出电流 500~600mA。',
            '键盘','可拆卸式20键机械键盘;外观颜色黑色/蓝色；材质玻璃，PC+ABS塑胶。',
          ]
        },
      ]
    }
  },
  {
    id: 20,
    name: '智能校园视频话机',
    type: '智能终端',
    imageSrc: 'image/product/product-zzxy.png',
    desc: '通信融合、安全监控、互动教育、信息公' +
      '告，实现校园内部及远程通信的即时连接、紧' +
      '急情况自动报警，交互界面可视化操作',
    jump:'hardware',
    detail:{
      list:[
        {
          name:'校园视频话机',
          type:'V300智能话机',
          imgs:[{src:'image/product/detail/znhjDetailList1.png',w:4.17}],
          spec:[
            '摄像头：单目200W像素，支持强光和逆光；',
            '芯片：高通8核方案，采用强劲硬件内核和最新的音视频处理技术，支持Opus编码和1080P高清双流；',
            '安卓：安卓9.0，快速对接第三方视讯软件；',
            '支持多种方式接入网：能够接入以太网、4G，可根据实际应用场景灵活选择入网方式；',
            '摈弃物理键盘：采用高清多点触控电容屏，如智能手机般的畅快体验；',
            '高清触摸屏：10英寸，1280*800 像素IPS高清屏，多点触控屏，打造更流畅的操作体验：'
          ],
          params:[
            '产品名称','V300智能话机',
            '操作系统','Android9.0',
            'CPU性能','8核，64位，1.8GHz',
            'FLASH存储','eMMC 16GB',
            'RAM内存','LPDDR3 2GB',
            '显示屏','10英寸，1280x800像素，多点触控IPS屏',
            '摄像头','单目，200万像素',
            '以太网','10/100Mbps 自适应',
            '4G','全网通，支持VOLTE',
            '读卡器(NFC tag，RF卡)','13.56MHz ；NFC（ISO 144443a，144443b），\n' +
            'SDK中具备控制接口',
            '麦克和扬声器','1、扬声器：单路、8Ω/2W ，免提麦克：单路，免提\n' +
            ';2、手柄：1个，磁感应',
            '视频编解码','1、支持H.264视频编解码\n' +
            ';2、支持VGA、720P、1080P@30fps等分辨率',
            '音频编解码','支持 G.711、AMR等',
            '二次开发','音视频VOIPSDK或调用安卓标准接口；',
            '环境温度','-20 ~ 55℃',
            '环境湿度','10 ~ 90%（非凝结）',
            '电源适配器','输入：AC100～220V,\n' +
            ';输出：DC12V/2A',
            '外形尺寸','360mm*260mm*35mm',
            '重量','1kg',
            '','',
          ]
        },
      ]
    }
  },
  {
    id: 21,
    name: '智能电子学生证(有屏)',
    type: '智能终端',
    imageSrc: 'image/product/product-zndj.png',
    desc: '身份验证、定位追踪、紧急求助、支付便' +
      '捷，实现对学生身份和安全的实时管理、异常' +
      '情况自动通知，使用状态可视化查询',
    jump:'hardware',
    detail:{
      list:[
        {
          name:'智慧校园',
          type:'电子学生证',
          imgs:[{src:'image/product/detail/dzxszDetailList1.png',w:3.12}],
          spec:[
            'OGS工艺触摸屏，重量轻强度高,物理按键逻辑清晰，一键唤醒；',
            '支持4G全网通，通信稳定，GPS+WIFI定位，轨迹全记录；',
            '坚固严密全贴合机身设计，防水；',
            'RFID快速读写，无感考勤；',
            '内置1000mAh大容量电池，无需频繁充电；',
            '支持OTA在线升级；'
          ],
          params:[
            '产品型号','NM-ESC-A1（屏显款）',
            '屏幕','1.54寸触摸屏',
            '芯片','紫光展锐8910S',
            '网络','中国移动/中国联通/中国电信/中国广电',
            '尺寸',' 1075910mm',
            '重量','  50g / 60g',
            '定位','GPS/北斗/WIFI/LBS',
            'SIM',' Nano SIM',
            '电池',' 1000mAh',
            'RFID',' 2.4G/13.56M',
            '按键',' 防水Type-C',
            '语音',' 麦克风&扬声器',
            '传感器',' 重力加速度传感器',
            'ID卡',' 便准ID尺寸证件照',
            '工作时间',' 7-10天',
            '摄像头',' 支持，可选配摄像头',
            '定制','四 核 RK3288,Cortex-A17',
            'CPU 频率','1.8GHz',
            'GPU ARM',' 支持OEMODM定制',
            '','',
          ]
        },
      ]
    }
  },
  {
    id: 39,
    name: '智能电子学生证(无屏)',
    type: '智能终端',
    imageSrc: 'image/product/productB39.png',
  },
  {
    id: 22,
    name: '智能电子班牌',
    type: '智能终端',
    imageSrc: 'image/product/product-dzbp.png',
    desc: '信息发布、课程管理、校园互动、安全显' +
      '示，实现对教学日程的实时更新、紧急通知自' +
      '动推送，内容展示可视化操作',
    jump:'hardware',
    detail:{
      list:[
        {
          name:'智慧校园',
          type:'电子班牌',
          imgs:[{src:'image/product/detail/dzbpDetailList1.png',w:5.1}],
          spec:[
            '横版：（宽×高×厚）524*355.6*29MM；',
            '接线口滑动门设计',
            '支持活体动态人脸识别、刷卡考勤;',
            '纯平背部埋线设计，方便隐蔽式安装。'
          ],
          params:[
            '触摸功能','全新投射式电容屏，G+G 10 点触摸，支持多点手势；',
            '显示','PC 全高清 HDMI 信号 1080P',
            'PC视频解码','1080P 全高清（Full HD）MPEG、H.265 等',
            '结构设计','铝合金边框，钣金后壳,散热合理',
            '推荐分辨率','1920*1080',
            '多媒体','立体声音响 3W X 2',
            '摄像头 ','高清200万双目活体动态摄像头',
            '指纹模组 ','可存储 500 枚指纹(选配)',
            '屏类型','原装高清LED背光液晶屏',
            '分辨率','1920*1080P',
            '响应时间','1.3/3.7 ms',
            '色彩总数','16.7M',
            '可视角度','178°（水平）178°（垂直）',
            '对比度','5000W:1（动态）',
            '刷新频率','60Hz',
            '抗光干扰','阳光、白炽灯、日光灯等强光变化时正常使用',
            '表面硬度','物理钢化,莫氏 7 级防爆玻璃',
            '系统版本','Android 5.X以上',
            'CPU 类型','四 核 RK3288,Cortex-A17',
            'CPU 频率','1.8GHz',
            'GPU ARM','Mali-T764MP',
            '系统内存','2G DDR3',
            '存储容量','8GB',
            'USB2.0','2 组',
            'HDMI','1 组',
            'LAN（RJ45）','1 组',
            'WiFi','有',
            'TF CARD','1 组',
            'OTG','1 组',
            '输入电源','90-260V~ 50/60Hz',
            '整机功耗','20W-45W',
            '待机功耗','≤0.5W',
            '音频输出功率','8Ω 3W×2',
            '工作温度','-20℃～50℃',
            '工作湿度','10%～95%',
            '存储温度','-20℃～70℃',
            '存储湿度','10%～95%',
            '海拔高度','5000 米以下',

          ]
        },
      ]
    }
  },
  {
    id: 23,
    name: 'AI防欺凌警报设备',
    type: '智能终端',
    imageSrc: 'image/product/productB31.png',
    desc: '行为分析、风险预警、实时干预、事件记' +
      '录，实现对校园欺凌行为的智能识别、潜在危' +
      '险自动提醒，处理过程可视化管理',
  },
  {
    id: 29,
    name: '支付宝团餐机',
    type: '智能终端',
    imageSrc: 'image/product/productB29.png',
    desc: '',
  },
  {
    id: 38,
    name: '三刷团餐机',
    type: '智能终端',
    imageSrc: 'image/product/productB38.png',
    desc: '',
  },
  // {
  //   id: 31,
  //   name: '防霸凌终端',
  //   type: '智能终端',
  //   imageSrc: 'image/product/productB31.png',
  //   desc: '',
  //   detail:{
  //     list:[
  //       {
  //         name:'智慧校园',
  //         type:'电子班牌',
  //         imgs:[{src:'image/product/productB31.png',w:5.1}],
  //       },
  //     ]
  //   }
  // },
  {
    id: 32,
    name: 'AI前比摄像头',
    type: '智能终端',
    imageSrc: 'image/product/productB32.png',
    desc: '',
  },
  {
    id: 33,
    name: 'pos款消费终端',
    type: '智能终端',
    imageSrc: 'image/product/productB33.png',
    desc: '',
  },
  {
    id: 34,
    name: '学生手表',
    type: '智能终端',
    imageSrc: 'image/product/productB34.png',
    desc: '',
  },
  {
    id: 35,
    name: '电子吹风机',
    type: '智能终端',
    imageSrc: 'image/product/productB35.png',
    desc: '',
  },
  {
    id: 36,
    name: '智慧饮水机',
    type: '智能终端',
    imageSrc: 'image/product/productB36.png',
    desc: '',
  },
  {
    id: 37,
    name: '智慧洗衣机',
    type: '智能终端',
    imageSrc: 'image/product/productB37.png',
    desc: '',
  },
  {
    id: 24,
    name: '校园安全系统',
    type: '智慧应用',
    imageSrc: 'image/product/product-xyaqxt.png',
    desc: '综合监控、紧急响应、访客管理、数据分' +
      '析，实现对校园安全的全方位实时保护、潜在' +
      '风险自动报警，安全状况可视化监控',
    jump:'soft',
    detail: {
      desc:'平安校园的创建是高校在新形势下推进校园治安综合治理体系和治理能力现代化的重要举措。其目的在于维护校园的和谐稳定，提升安全管理和教育工作的实效，为学校各项事业发展提供稳固的基础。',
      img:{src:'image/product/detail/soft24.png',w:7.11},
      icons:[
        {src:'image/product/icon/icon241.png',title:'门禁管理'},
        {src:'image/product/icon/icon242.png',title:'访客管理'},
        {src:'image/product/icon/icon243.png',title:'用户友好的操作界面'},
        {src:'image/product/icon/icon244.png',title:'防欺凌系统'},
        {src:'image/product/icon/icon245.png',title:'智能穿戴设备'},
        {src:'image/product/icon/icon246.png',title:'请假管理'},
        {src:'image/product/icon/icon247.png',title:'安全性与隐私保护'},
      ]
    }

  },
  {
    id: 25,
    name: '校园生活系统',
    type: '智慧应用',
    imageSrc: 'image/product/product-xysh.png',
    desc: '服务集成、便捷支付、健康监测、互动交' +
      '流，实现对校园生活的全面支持、异常情况自' +
      '动反馈，生活服务可视化管理',
    jump:'soft',
    detail: {
      desc:'这套系统能够解决学生在校园生活中所面临的诸多问题，提高校园生活服务的效率和质量，提升学生的生活品质和学习体验，有效解决信息不对称、服务缺乏个性化和学生反馈不及时等问题。校园生活系统的出现能够解决这些问题，提供全方位、个性化的服务。且用户界面美观、指引性友好，操作简单。',
      img:{src:'image/product/detail/soft25.png',w:7.11},
      icons:[
        {src:'image/product/icon/icon251.png',title:'卡务中心'},
        {src:'image/product/icon/icon252.png',title:'食堂消费系统'},
        {src:'image/product/icon/icon253.png',title:'营业报表统计'},
        {src:'image/product/icon/icon254.png',title:'宿舍管理'},
        {src:'image/product/icon/icon255.png',title:'图书管理'},
      ]
    }
  },
  {
    id: 26,
    name: '教务总务系统',
    type: '智慧应用',
    imageSrc: 'image/product/product-jwzw.png',
    desc: '课程调度、资源分配、维护管理、效能分' +
      '析，实现对学校日常运行的高效协调、问题即' +
      '时响应，运维状态可视化监控',
    jump:'soft',
    detail: {
      desc:'提高教学管理的效率，减轻教务人员的工作负担，同时为学生提供便捷的学习支持服务。通过自动化和数字化的教学管理流程，系统有助于提升整个教育机构的运作质量和管理水平。',
      img:{src:'image/product/detail/soft26.png',w:7.11},
      icons:[
        {src:'image/product/icon/icon261.png',title:'课程管理'},
        {src:'image/product/icon/icon262.png',title:'成绩管理'},
        {src:'image/product/icon/icon263.png',title:'考勤管理'},
        {src:'image/product/icon/icon264.png',title:'教室调度'},
        {src:'image/product/icon/icon265.png',title:'排课系统'},
        {src:'image/product/icon/icon266.png',title:'考试管理'},
        {src:'image/product/icon/icon267.png',title:'通知发布'},
        {src:'image/product/icon/icon268.png',title:'请假管理'},
      ]
    }
  },


]

export default list



// WEBPACK FOOTER //
// ./src/pages/product/productsData.js